import { render } from "./PerformancePage.vue?vue&type=template&id=0fc1209c"
import script from "./PerformancePage.vue?vue&type=script&lang=js"
export * from "./PerformancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__